import './styles/Profile.scss';
import { App_ViewModeMap, MemberUser_TypeMap, Miscellaneous_PageMap, Payment_StatusMap, System_DeviceOrientationMap } from '../../assets/keyMap';
import { Fragment, useContext, useState, useRef, useEffect, ReactElement } from 'react';
import { useHistory } from 'react-router';
import { AppContext, ExAppContext } from '../../Context';
import { IonDateString, IonDateFormat, IonDate } from '../../components/IonDate';
import { Share } from '@capacitor/share';
import QRCode from 'react-qr-code';
// import { pdf, PDFViewer } from '@react-pdf/renderer'; ---deprecated, moved to ECert.tsx
// import ECerticate from '../../exComponents/ECertificate'; ---deprecated, moved to ECert.tsx
// import { Filesystem, Directory, Encoding } from '@capacitor/filesystem'; ---deprecated, moved to ECert.tsx
import { Mediastore } from '@agorapulse/capacitor-mediastore';
// import { Browser } from '@capacitor/browser'; ---deprecated, moved to ECert.tsx
// import { FileOpener } from '@capacitor-community/file-opener'; ---deprecated, moved to ECert.tsx

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//muis
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EditNoteIcon from '@mui/icons-material/EditNote';
import KeyIcon from '@mui/icons-material/Key';
import PasswordIcon from '@mui/icons-material/Password';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import DescriptionIcon from '@mui/icons-material/Description';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Diversity3Icon from '@mui/icons-material/Diversity3';
// import ShareIcon from '@mui/icons-material/Share'; ---deprecated of unuse
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

//graphics
import PPKMLogoSquare from '../../assets/images/logos/ppkmLogo1_square.png';
// import PPKMLogo1Transparent from '../../assets/images/logos/ppkmLogo1_transparent.png';
import PPKMLogo2 from '../../assets/images/logos/ppkmLogo2.png';
import MembershipCardBack from '../../assets/images/general/membershipCardBack.png';
import { profile } from 'console';

//classes
import MemberUser from '../../classes/memberUser';
import MemberType from '../../exClasses/memberType';
import CommitteeType from '../../exClasses/committeeType';
import MembershipContract from '../../exClasses/membershipContract';
import Payment from '../../exClasses/payment';
import { isPlatform } from '@ionic/react';

// class AuthorityInfo {
//     public name: string = '';
//     public signature_url: string = '';
//     public authority_type: number = 0; //0 - president, 1 - secretary

//     constructor(name: string, signature_url: string, authority_stype: number) {
//         this.name = name;
//         this.signature_url = signature_url;
//         this.authority_type = authority_stype;
//     }
// } ---deprecated, moved to ECert.tsx
class ListItem {
    public icon: ReactElement = {} as ReactElement;
    public label: string = '';
    public navigationAction: any = {};

    constructor(icon: ReactElement, label: string, navigationAction: any) {
        this.icon = icon;
        this.label = label;
        this.navigationAction = navigationAction;
    }

    public SetNavigationAction = (newAction: any) => {
        this.navigationAction = newAction;
    }
}

interface Props {

}

const nonstate = {
    shareAppText: 'Install PPK Malaysia Super App and Enjoy Full Membership Features Now!' + '\n\nandroid: {androidAppLink}' + '\n\nios: {iosAppLink}'
}

const Profile: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [generalSettingListItems, SetGeneralSettingListItems] = useState<ListItem[]>([] as ListItem[]);
    const [informationListItems, SetInformationListItems] = useState<ListItem[]>([] as ListItem[]);
    const [contractPayments, SetContractPayments] = useState<Payment[]>([] as Payment[]);
    const [profilePicLoadErr, SetProfilePicLoadErr] = useState(false);
    //for ecert generation
    // const [presidentInfo, SetPresidentInfo] = useState<AuthorityInfo | null>(null);
    // const [secretaryInfo, SetSecretaryInfo] = useState<AuthorityInfo | null>(null);
    //history objs
    const history = useHistory();
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    //refs
    // const presidentInfoRef = useRef<AuthorityInfo | null>(null);
    // const secretaryInfoRef = useRef<AuthorityInfo | null>(null); ---deprecated, moved to ECert.tsx

    //watchers
    //test
    // useEffect(() => {
    //     console.log('ProfileTest: ' + JSON.stringify(presidentInfo));
    //     console.log('ProfileTest: ' + JSON.stringify(secretaryInfo));
    // }, [presidentInfo, secretaryInfo]);

    //initialize setup content
    useEffect(() => {
        SetGeneralSettingListItems([...[
            new ListItem(<EditNoteIcon />, 'Manage Membership', () => { history.push('/ManageMembership'); }),
            // new ListItem(<EditNoteIcon />, 'Edit Profile', () => { history.push('/EditProfile'); }), ---deprecated
            new ListItem(<KeyIcon />, 'Change Password', () => { history.push('/ChangePassword'); }),
            new ListItem(<PasswordIcon />, 'Setup 6-Digits Pin', () => { history.push('/ResetPin'); }),
            new ListItem(<CardMembershipIcon />, 'E-Certificate', () => /*OnDownloadECertClicked()*/ history.push('/ECert')),
        ]]);
        SetInformationListItems([...[
            new ListItem(<Diversity3Icon />, 'PPKM Members', () => { history.push('/MembersList'); }),
            new ListItem(<SmartphoneIcon />, 'About App', () => { history.push('/Miscellaneous/' + Miscellaneous_PageMap.ABOUT_APP); }),
            new ListItem(<DescriptionIcon />, 'Terms & Conditions', () => { history.push('/Miscellaneous/' + Miscellaneous_PageMap.TERMS_AND_CONDITIONS); }),
            new ListItem(<VerifiedUserIcon />, 'Privacy Policy', () => { history.push('/Miscellaneous/' + Miscellaneous_PageMap.PRIVACY_POLICY); }),
            new ListItem(<ContactSupportIcon />, 'User Manuals', () => { history.push('/Miscellaneous/' + Miscellaneous_PageMap.USER_MANUALS) }),
            new ListItem(<SupportAgentIcon />, 'Contact Us', () => { history.push('/Miscellaneous/' + Miscellaneous_PageMap.CONTACT_US) }),
            // new ListItem(<ShareIcon />, 'Share This App', () => { Share.share({ text: nonstate.shareAppText.replace('{androidAppLink}', appContext.appLink.android).replace('{iosAppLink}', appContext.appLink.ios) }) }),
            new ListItem(<LogoutIcon />, 'Sign Out', () => OnLogoutClicked())
        ]]);

        // //for e-cert generation
        // databaseInterfaceController.Queue('fetchECertSignatures', [
        //     ['fetchECertSignatures', 'true'],
        // ]); ---deprecated, moved to ECert.tsx
    }, []);

    //watch for membershipContracts update fetchPayments
    useEffect(() => {
        if (exAppContext.membershipContracts.length > 0) {
            const paymentIDs = [] as string[];

            exAppContext.membershipContracts.map((contract: MembershipContract) => {
                paymentIDs.push(contract.paymentID);
            });

            //fetch payments
            databaseInterfaceController.Queue('fetchPayments', [
                ['fetchPayments', 'true'],
                ['paymentIDs', paymentIDs.join(',')]
            ]);
        }
    }, [exAppContext.membershipContracts]);

    //watch for databaseResultActions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchPayments':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            const payments = [] as Payment[];
                            resObjs.map((resObj: any) => {
                                payments.push(new Payment(
                                    resObj['paymentID'],
                                    resObj['invoice_no'],
                                    resObj['type'],
                                    resObj['status'],
                                    resObj['contact_salutation'],
                                    resObj['contact_other_salutation'],
                                    resObj['contact_name'],
                                    resObj['contact_hp'],
                                    resObj['contact_office_no'],
                                    resObj['contact_email'],
                                    resObj['billing_name'],
                                    resObj['billing_address'],
                                    resObj['e_invoice_pin'],
                                    resObj['itemIDs'],
                                    resObj['pax'],
                                    resObj['amounts'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['remarks']
                                ));
                            });
                            SetContractPayments([...payments]);
                        } else {
                            console.log('fetchPaymentsErr: ' + res);
                        }
                        break;
                    // case 'fetchECertSignatures':
                    //     if (!JSON.stringify(res).includes('_false')) {
                    //         let resObjs = [] as any[];
                    //         try {
                    //             resObjs = JSON.parse(res) as any[];
                    //         } catch {
                    //             resObjs = res as any[];
                    //         }
                    //         resObjs.map((res: any) => {
                    //             if (res['designation'] == '0') {
                    //                 presidentInfoRef.current = new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation']));
                    //             }
                    //             // SetPresidentInfo(new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation'])));
                    //             else {
                    //                 secretaryInfoRef.current = new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation']));
                    //             }
                    //             // SetSecretaryInfo(new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation'])));
                    //         });
                    //     } else {
                    //         console.log('fetchECertSignaturesErr: ' + res);
                    //     }
                    //     break; ---deprecated, moved to ECert.tsx
                }
            }
            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchPayments':
                // case 'fetchECertSignatures': ---deprecated, moved to ECert.tsx
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    // const OnViewModeToggled = (viewMode: number) => {
    //     exAppContext.SetViewMode(viewMode);
    //     appContext.SetStorageRequestMode('set system');
    //     appContext.SetStorageRequestParams([
    //         ['system:viewMode', viewMode]
    //     ]);
    // } --deprecated
    const OnLogoutClicked = () => {
        appContext.SetWaitScreenShouldShow(true);
        appContext.SetWaitScreenMessage('Signing out please wait');
        setTimeout(() => {
            appContext.SetWaitScreenShouldShow(false);
            appContext.SetUser({} as MemberUser);
            appContext.SetPopupMessage('Your account has been safely signed out.');
        }, 3000);
    }
    // const OnDownloadECertClicked = async () => {
    //     if (
    //         presidentInfoRef.current
    //         && secretaryInfoRef.current
    //     ) {
    //         appContext.SetWaitScreenMessage('generating e-certificate\nplease wait');
    //         appContext.SetWaitScreenShouldShow(true);
    //         const blob = await pdf(<ECerticate presidentInfo={presidentInfoRef.current} secretaryInfo={secretaryInfoRef.current} membership={exAppContext.membership} user={appContext.user} memberTypes={exAppContext.memberTypes} />).toBlob();
    //         const fileName = 'ppkm-e-certificate-' + exAppContext.membership.memberID + '.pdf';
    //         if (!isPlatform('hybrid')) {
    //             const url = URL.createObjectURL(blob);
    //             Browser.open({ url: url });
    //             appContext.SetWaitScreenShouldShow(false);
    //             // const link = document.createElement('a');
    //             // link.href = url;
    //             // link.download = fileName;
    //             // link.click();
    //             // URL.revokeObjectURL(url); // Clean up
    //             // appContext.SetPopupMessage('Successfully saved to downloads folder.');
    //             // appContext.SetWaitScreenShouldShow(false);
    //         } else {
    //             const reader = new FileReader();
    //             reader.readAsDataURL(blob);
    //             reader.onloadend = async () => {
    //                 if (reader.result != null) {
    //                     const base64data = reader.result.toString().split(',')[1];
    //                     await DownloadEcert(fileName, base64data);
    //                 }
    //             };
    //         }
    //     } else {
    //         appContext.SetPopupMessage('Failed to generate e-certificate,\nPlease try again.');
    //     }
    // } ---deprecated, moved to ECert.tsx
    // const SaveFileToLocal = async (directory: Directory, base64String: string, fileName: string) => {
    //     await Filesystem.writeFile({
    //         path: fileName,
    //         data: base64String, // your data to write (ex. base64)
    //         directory: /*Directory.Documents ---not working android 10 onwards*/Directory.Cache,
    //         recursive: true
    //     });
    //     const uri = await Filesystem.getUri({
    //         directory: directory,
    //         path: fileName
    //     });

    //     if (uri)
    //         return uri.uri;
    //     else
    //         return '';
    // } ---deprecated, moved to ECert.tsx
    // const DownloadEcert = async (fileName: string, base64String: string) => {

    //     if (isPlatform('hybrid')) {
    //         const uri = await SaveFileToLocal(Directory.Cache, base64String, fileName);
    //         // const SaveFile = async () => {
    //         //     try {
    //         //         // await Mediastore.saveToDownloads({
    //         //         //     path: uri,
    //         //         //     filename: fileName
    //         //         // }).then((res: any) => {
    //         //         //     console.log('saveToDownloadRes: ' + JSON.stringify(res));
    //         //         // }).catch((err: string) => {
    //         //         //     console.log('saveToDownloadsErr: ' + err);
    //         //         // });
    //         //         // appContext.SetPopupMessage('Successfully saved to downloads folder.');
    //         //         Browser.open({ url: uri });
    //         //         appContext.SetWaitScreenShouldShow(false);
    //         //     } catch (err: any) {
    //         //         console.log('getUriErr: ' + JSON.stringify(err));
    //         //         appContext.SetPopupMessage('Fail to download picture.');
    //         //     }
    //         // }
    //         // await SaveFile();
    //         //open file 
    //         // console.log('checkuri: ' + uri);
    //         await FileOpener.open({
    //             filePath: uri,
    //             contentType: 'application/pdf',
    //         })
    //     } else {
    //         var a = document.createElement("a"); //Create <a>
    //         a.href = "data:image/png;base64," + base64String; //Image Base64 Goes here
    //         a.download = fileName; //File name Here
    //         a.click(); //Downloaded file
    //         console.log('shouldDownloadImage');
    //     }
    //     appContext.SetWaitScreenShouldShow(false);
    // } ---deprecated, moved to ECert.tsx

    //render function
    const RenderMembershipCard = () => {
        const lastMembershipContract = GetLastRenewedContract(exAppContext.membershipContracts);

        if (Object.keys(appContext.user).length > 0) {
            return (
                <div className='membership-card' onClick={() => history.push('/ManageMembership')}>
                    <img className='membership-card-bg' src={MembershipCardBack} />
                    <img className='membership-card-logo-img' src={PPKMLogo2} />
                    <div className='membership-card-col wide'>
                        <div className='membership-card-name-block'>
                            <span className='membership-card-name-lbl'>{appContext.user.name}</span>
                            <span className='membership-card-name-lbl ex'>{exAppContext.membership.company_name}</span>
                            <span className='membership-card-name-lbl ex'>Mem. No. {appContext.user.memberID}</span>
                        </div>
                    </div>
                    {/** user profile picture, user memberID, expiry date */}
                    <div className='membership-card-col'>
                        {
                            profilePicLoadErr ?
                                <AccountCircleIcon />
                                :
                                <img className='membership-card-profile-img' src={appContext.user.profile_image} onError={() => SetProfilePicLoadErr(true)} />
                        }
                        <div className='membership-card-qr-block'>
                            <QRCode value={appContext.user.userID} />
                            <span className='membership-card-qr-lbl'>{appContext.user.userID}</span>
                        </div>
                        <span className='membership-card-expiry-date-lbl'>VALID THRU: {IonDateString(lastMembershipContract.max_term, IonDateFormat.LONG_DATE)}</span>
                    </div>
                </div>
            )
        } else
            return null;
    }
    const RenderGeneralSettingsBlock = () => {
        return (
            <div className='list-block'>
                <span className='list-title'>General Settings</span>
                {
                    generalSettingListItems.map((settingList: ListItem, i: number) => {
                        return (
                            <div className='list-item' onClick={() => { settingList.navigationAction(); }} key={'general-list-item-' + i}>
                                <div className='list-icon'>{settingList.icon}</div>
                                <span className='list-lbl'>{settingList.label}</span>
                                <div className='arrow-forward-icon'><ArrowForwardIosIcon /></div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    const RenderInformationBlock = () => {
        return (
            <div className='list-block'>
                <span className='list-title'>Information</span>
                {
                    informationListItems.map((settingList: ListItem, i: number) => {
                        return (
                            <div className='list-item' onClick={() => { settingList.navigationAction(); }} key={'information-list-item-' + i}>
                                <div className='list-icon'>{settingList.icon}</div>
                                <span className='list-lbl'>{settingList.label}</span>
                                <div className='arrow-forward-icon'><ArrowForwardIosIcon /></div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    //exe fuctions
    // const GetMembershipTypeByID = (typeID: string) => {
    //     let res = {} as MemberType;
    //     exAppContext.memberTypes.map((memberType: MemberType) => {
    //         if (memberType.member_typeID == typeID)
    //             res = memberType;
    //     });
    //     return res;
    // } ---deprecated to header
    // const GetCommitteeTypeByID = (typeID: string) => {
    //     let res = {} as CommitteeType;
    //     exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
    //         if (committeeType.committee_typeID == typeID)
    //             res = committeeType;
    //     });
    //     return res;
    // } ---deprecated to header
    // const GetAccountTypeByID = (typeID: string) => {
    //     let res = '';
    //     if (IsCorporate()) {
    //         if (typeID == MemberUser_TypeMap.APPOINTED)
    //             return '/Appt.';
    //         else if (typeID == MemberUser_TypeMap.ALTERNATE)
    //             return '/Alt.';
    //         else if (typeID == MemberUser_TypeMap.OTHERS)
    //             return '/Oth.';
    //     }
    //     return res;
    // } ---deprecated to header
    const SortMembershipContracts = (membershipContracts: MembershipContract[]) => {
        //sort by datetime created descending
        const sorted = [] as MembershipContract[];
        membershipContracts.map((membershipContract: MembershipContract) => {
            let isSorted = false;
            sorted.map((_membershipContract: MembershipContract, i: number) => {
                if (
                    !isSorted &&
                    membershipContract.datetime_created != null &&
                    _membershipContract.datetime_created != null &&
                    membershipContract.datetime_created > _membershipContract.datetime_created) {
                    sorted.splice(i, 0, membershipContract);
                    isSorted = true;
                }
            });

            if (!isSorted)
                sorted.push(membershipContract);
        });
        return sorted;
    }
    const GetContractPaymentByID = (_contractPayments: Payment[], paymentID: string) => {
        let res = {} as Payment;
        _contractPayments.map((payment: Payment) => {
            if (payment.paymentID == paymentID)
                res = payment;
        })
        return res;
    }
    const GetLastRenewedContract = (membershipContracts: MembershipContract[]) => {
        const sorted = SortMembershipContracts(membershipContracts);
        let res = {} as MembershipContract;
        let isFound = false;
        sorted.map((contract: MembershipContract) => {
            const contractPayment = GetContractPaymentByID(contractPayments, contract.paymentID);
            if (!isFound && contractPayment.status == Payment_StatusMap.PAID) {
                res = contract;
                isFound = true;
            }
        });
        return res;
    }

    //checing functions
    const IsCorporate = () => {
        let res = false;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (
                memberType.member_typeID == exAppContext.membership.member_typeID
                && memberType.label.toLowerCase().includes('corporate')
            ) {
                res = true;
            }
        });
        return res;
    }

    return (
        <div className={'Profile ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : '')}>
            <div className='title-row'>
                <span className='title-lbl'>My Membership</span>
                {/* {
                    Object.keys(appContext.user).length > 0 ?
                        appContext.user.memberID.length > 0 && appContext.user.committee_typeID.length > 0 ?
                            <div className='mode-switch-toggle'>
                                <button className='mode-switch-toggle-btn' onClick={() => OnViewModeToggled(App_ViewModeMap.MEMBER)}>{GetMembershipTypeByID(exAppContext.membership.member_typeID).label}<span className='toggle-btn-lbl'>{GetAccountTypeByID(appContext.user.type)}</span></button>
                                <button className='mode-switch-toggle-btn' onClick={() => OnViewModeToggled(App_ViewModeMap.COMMITTEE)}>{GetCommitteeTypeByID(appContext.user.committee_typeID).label}</button>
                                <span className={'mode-switch-toggle-cursor ' + (exAppContext.viewMode == App_ViewModeMap.MEMBER ? 'membership' : 'committee')}>{
                                    exAppContext.viewMode == App_ViewModeMap.MEMBER ?
                                        <Fragment>
                                            {GetMembershipTypeByID(exAppContext.membership.member_typeID).label}
                                            <span className='mode-switch-toggle-lbl'>{GetAccountTypeByID(appContext.user.type)}</span>
                                        </Fragment>
                                        :
                                        GetCommitteeTypeByID(appContext.user.committee_typeID).label
                                }
                                </span>
                            </div>
                            :
                            (
                                appContext.user.memberID.length > 0 ?
                                    //render membership membertype
                                    <span className='mode-lbl membership'>{GetMembershipTypeByID(exAppContext.membership.member_typeID).label}</span>
                                    :
                                    (
                                        appContext.user.committee_typeID.length > 0 ?
                                            //render committee type
                                            <span className='mode-lbl committee'>{GetCommitteeTypeByID(appContext.user.committee_typeID).label}</span>
                                            :
                                            <span className='mode-lbl dummy'></span>
                                    )
                            )
                        :
                        null
                } ---deprecated to header*/}
            </div>
            {RenderMembershipCard()}
            {RenderGeneralSettingsBlock()}
            {RenderInformationBlock()}
            {/* <PDFViewer>
                <ECerticate presidentInfo={presidentInfo} secretaryInfo={secretaryInfo} membership={exAppContext.membership} user={appContext.user} memberTypes={exAppContext.memberTypes} />
            </PDFViewer> */}
        </div>
    );
};
export default Profile;